(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-devoluciones"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('devoluciones-form');
    if (!form) return;

    var cuerpo = document.getElementById('devolucion-cuerpo');
    var numero = document.getElementById('devolucion-nombre');
    var email = document.getElementById('devolucion-email');
    var motivo = document.getElementById('devolucion-motivo');
    var descripcion = document.getElementById('devolucion-descripcion');
    var fotos = document.getElementById('devolucion-fotos');
    var terminos = document.getElementById('devolucion-terminos');
    var boton = document.getElementById('devolucion-boton');

    function construirCuerpo() {
      var lineas = [];
      lineas.push('Número de pedido: ' + (numero.value || ''));
      lineas.push('Correo electrónico: ' + (email.value || ''));
      lineas.push('Motivo: ' + (motivo.value || ''));
      lineas.push('Descripción: ' + (descripcion.value || ''));
      if (fotos && fotos.value.trim()) {
        lineas.push('Enlace a fotografías: ' + fotos.value.trim());
      }
      cuerpo.value = lineas.join('\n');
    }

    terminos.addEventListener('change', function() {
      if (terminos.checked) {
        terminos.setCustomValidity('');
      } else {
        terminos.setCustomValidity('Debes aceptar la Política de devoluciones de BRAVA.');
      }
    });

    form.addEventListener('submit', function(e) {
      if (form.dataset.submitting === 'true') {
        e.preventDefault();
        return;
      }

      if (!terminos.checked) {
        terminos.setCustomValidity('Debes aceptar la Política de devoluciones de BRAVA.');
        terminos.reportValidity();
        e.preventDefault();
        return;
      }

      construirCuerpo();

      if (cuerpo.value.trim() === '' || !numero.value.trim() || !email.value.trim() || !motivo.value || !descripcion.value.trim()) {
        e.preventDefault();
        return;
      }

      form.dataset.submitting = 'true';
      boton.disabled = true;
      boton.textContent = 'ENVIANDO...';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('[data-faq-item]');
    
    faqItems.forEach(item => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');
      
      trigger.addEventListener('click', function() {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Close all other items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
            const otherContent = otherItem.querySelector('[data-faq-content]');
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherContent.style.maxHeight = '0';
          }
        });
        
        // Toggle current item
        trigger.setAttribute('aria-expanded', !isExpanded);
        content.style.maxHeight = !isExpanded ? content.scrollHeight + 'px' : '0';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
